const renderPage = (loading, error) => !loading && !error;

export default renderPage;
